/*                                                         */
import { eventQBus } from "@otto-ec/global-resources/event-q-bus";

declare global {
  interface Window {
    o_apps: {
      runningInApp: () => boolean;
    };
  }
}

export async function dialog(): Promise<void> {
  const prefix = "siteframe-dialog-v1";
  const appClassName = `${prefix}--app`;

  const isInApp = async (): Promise<boolean> => {
    /**
 *
 *
 */
    if (document.body.classList.contains(appClassName)) {
      return true;
    }

    /*                                                                  */
    await eventQBus.once("apps.global.assets-loaded");

    return window.o_apps.runningInApp();
  };

  if (await isInApp()) {
    document.body.classList.add(appClassName);
    /*                                                                                             */
  }

  document.body.classList.add(`${prefix}--ready`);
}
